<app-toast></app-toast>

<div class="drawer h-full" [ngClass]="{'lg:drawer-open': !(sidebarCollapsed$ | async)}">
    <input id="left-sidebar-drawer" type="checkbox" class="drawer-toggle" />

    <div class="drawer-content h-full min-w-0 overflow-hidden bg-base-200">
        <div class="flex h-full min-w-0 overflow-hidden">

            <!-- Hlavní oblast: topbar + obsah -->
            <div class="flex-1 flex flex-col min-w-0 overflow-hidden h-full">
                <app-topbar class="shrink-0"></app-topbar>
                <!-- FIXME responsivita marginu -->
                <ngx-simplebar class="flex-1 w-full min-h-0 min-w-0 p-2 md:p-4"
                               [class.overflow-hidden]="isFluidMode$ | async">
                    <div [ngClass]="contentClass$ | async">
                        <router-outlet></router-outlet>
                    </div>
                </ngx-simplebar>
            </div>

            <!-- Pravý panel: jedna DOM instance, CSS mění push/fullscreen/mobile -->
            @if (rightPanel.isVisible()) {
                <aside class="rp-aside h-full flex flex-col bg-base-100 overflow-hidden"
                       [class.rp-open]="rightPanel.isOpen() && !rightPanel.isFullscreen()"
                       [class.rp-fullscreen]="rightPanel.isFullscreen()"
                       [class.rp-overlay]="!!rightPanel.config()!.overlayBelowWidth"
                       [style.--rp-w]="rightPanel.config()!.width ?? '300px'">
                    <ng-container [ngTemplateOutlet]="rightPanel.config()!.headerTemplate" />
                    <ng-container [ngTemplateOutlet]="rightPanel.config()!.bodyTemplate" />
                </aside>
            }

            <!-- Sbalený pruh: desktop only, jen s collapsedTemplate -->
            @if (rightPanel.isVisible() && !rightPanel.isOpen() && !rightPanel.isFullscreen() && rightPanel.config()?.collapsedTemplate) {
                <div class="hidden md:flex flex-col items-center bg-base-100 border-l border-base-content/10 shrink-0 w-[52px]">
                    <div class="flex items-center justify-center min-h-16 border-b border-base-content/10 w-full shrink-0">
                        <button class="btn btn-ghost btn-sm btn-square" (click)="rightPanel.open()">
                            <app-icon icon="ph:caret-double-left" size="md" class="opacity-50 hover:opacity-100" />
                        </button>
                    </div>
                    <div class="flex flex-col items-center gap-2 py-3">
                        <ng-container [ngTemplateOutlet]="rightPanel.config()!.collapsedTemplate!" />
                    </div>
                </div>
            }

        </div>

        <!-- Backdrop: overlay (mobile + medium viewports < 1400px, jen pro rp-overlay panely) -->
        @if (rightPanel.isOpen() && rightPanel.isVisible() && !rightPanel.isFullscreen() && rightPanel.config()!.overlayBelowWidth) {
            <div class="fixed inset-0 bg-black/40 z-[1049] min-[1400px]:hidden"
                 (click)="rightPanel.closeFromBackdrop()"></div>
        }

        <!-- Backdrop: fullscreen (desktop) -->
        @if (rightPanel.isFullscreen() && rightPanel.isVisible()) {
            <div class="fixed inset-0 bg-black/20 z-[1055] hidden md:block"
                 (click)="rightPanel.exitFullscreenFromBackdrop()"></div>
        }
    </div>

    <!-- Levý sidebar (beze změny) -->
    <div class="drawer-side z-50">
        <label for="left-sidebar-drawer" [attr.aria-label]="'layout.sidebar.close' | translate" class="drawer-overlay"></label>
        <app-left-sidebar class="bg-base-100 block w-64 xl:w-72"></app-left-sidebar>
    </div>
</div>
